import { Column, EndpointType, Filter } from '@nirvana/shared/dtos/types/shared/filters';
import { ActionTakenEnum, DetectingModules, DetectingTechnologies } from '@nirvana/shared/dtos/types/shared/threats';
import { CommonThreatsNavigationHelper } from './common.threats.navigation.helper';
import { ThreatsBreakdownNavigationFiltersParams } from '../navigation.interfaces';

export class ThreatsBreakdownNavigationHelper {
  public static getDisplayedColumns(): Array<Column> {
    return [
      Column.LAST_DETECTED,
      Column.ENDPOINT_TYPE,
      Column.DETECTING_MODULE,
      Column.DETECTING_TECHNOLOGY,
      Column.ACTION_TAKEN,
    ];
  }

  public static getFiltersForNavigationItem(params: ThreatsBreakdownNavigationFiltersParams): Array<Filter> {
    const filters = [
      CommonThreatsNavigationHelper.getLastDetectedOnFilterFromTimeRange(params.timeRange),
      CommonThreatsNavigationHelper.getCategoryFilter(),
      ThreatsBreakdownNavigationHelper.getActionsTakenFilter(),
      CommonThreatsNavigationHelper.getDeviceNameFilter(),
      ThreatsBreakdownNavigationHelper.getEndpointTypeFilter(params.endpointTypes),
      ThreatsBreakdownNavigationHelper.getDetectingModuleFilter(),
      ThreatsBreakdownNavigationHelper.getDetectingTechnologyFilter(),
    ];

    return !params.isPartner ? filters : filters.concat(CommonThreatsNavigationHelper.getCompanyFilter(params.targets));
  }

  private static getActionsTakenFilter(): Filter {
    return {
      actionTaken: {
        in: [
          ActionTakenEnum.DELETED,
          ActionTakenEnum.BLOCKED,
          ActionTakenEnum.QUARANTINED,
          ActionTakenEnum.REMEDIATED,
          ActionTakenEnum.MALICIOUS_PROCESS_KILLED,
          ActionTakenEnum.REPLACED_ATTACHMENT,
          ActionTakenEnum.REJECTED_EMAIL,
          ActionTakenEnum.DELETED_ATTACHMENT,
        ],
      },
    };
  }

  private static getDetectingTechnologyFilter(): Filter {
    return {
      detectingTechnology: {
        in: [
          DetectingTechnologies.ANTIMALWARE_ON_ACCESS,
          DetectingTechnologies.ANTIMALWARE_ON_DEMAND,
          DetectingTechnologies.ANTIMALWARE_ON_DEMAND_SCHEDULED_SCANS,
          DetectingTechnologies.ANTIMALWARE_CONTEXTUAL_SCAN,
          DetectingTechnologies.ANTIMALWARE_AVC,
          DetectingTechnologies.ANTIMALWARE_HYPER_DETECT,
          DetectingTechnologies.ANTIMALWARE_ON_EXECUTE_FILELESS_ATTACK_PROTECTION,
          DetectingTechnologies.ANTIMALWARE_ON_EXECUTE_ATC,
          DetectingTechnologies.ANTIMALWARE_ADVANCED_ANTI_EXPLOIT,
          DetectingTechnologies.NETWORK_PROTECTION_WEB_PROTECTION_WEB_TRAFFIC_SCAN,
          DetectingTechnologies.NETWORK_PROTECTION_WEB_PROTECTION_ANTIPHISING,
          DetectingTechnologies.NETWORK_PROTECTION_WEB_PROTECTION_HYPER_DETECT,
          DetectingTechnologies.NETWORK_PROTECTION_NETWORK_ATTACK_DEFENSE,
          DetectingTechnologies.STORAGE_PROTECTION_STORAGE_PROTECTION,
          DetectingTechnologies.EXCHANGE_PROTECTION_ANTIMALWARE,
        ],
      },
    };
  }

  private static getDetectingModuleFilter(): Filter {
    return {
      detectingModule: {
        in: [
          DetectingModules.ANTIMALWARE,
          DetectingModules.NETWORK_PROTECTION,
          DetectingModules.STORAGE_PROTECTION,
          DetectingModules.EXCHANGE_PROTECTION,
        ],
      },
    };
  }

  private static getEndpointTypeFilter(endpointTypes: Array<EndpointType>): Filter {
    return {
      endpointType: {
        in: endpointTypes,
      },
    };
  }
}
